export default __webpack_public_path__ + "static/media/play-store.6245dd76.svg";